import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';

import { JwtHelperService } from '@auth0/angular-jwt';
import { Store } from '@ngxs/store';

import { AppState } from '../state/app.state';

/**
 * This HttpInterceptor add JWT token - IdToken (Auth0) - to each request if it is saved in application state
 * (loggedUser.loggedUserToken).
 * Token is added into Authorization HTTP header (Authorization: Bearer ID_TOKEN)
 *
 * ... if token is expired, token will be NOT added to request and will be REMOVED from store
 */
@Injectable()
export class JWTTokenInterceptor implements HttpInterceptor {
  loggedUser$ = this.store.select(AppState.getUser);

  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(private store: Store) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.loggedUser$
      ? this.loggedUser$.pipe(
          first(),
          switchMap(loggedUser => {
            if (loggedUser && loggedUser.idToken) {
              if (!this.jwtHelper.isTokenExpired(loggedUser.idToken)) {
                return next.handle(
                  request.clone({
                    setHeaders: {
                      'x-authorization': `Bearer ${loggedUser.idToken}`
                    }
                  })
                );
              } else {
                return next.handle(request);
              }
            } else {
              return next.handle(request);
            }
          })
        )
      : next.handle(request);
  }
}
